import { env } from '@/env';
import { chessLimuloAcceso } from '@/lib/chess/chessLimuloAcceso';

/**
 * La PARTITA CONTRO IL BOT degli scacchi (E7 di ADR-0193; Luca, I-561/I-562, 09/10): la tessera «Gioca contro il bot» nella Hub e la
 * schermata `/chess/bot`. Acceso SOLO col flag suo (`VITE_FEATURE_CHESS_BOT_ENABLED`, opt-in, `.env.staging`) in AND con gli scacchi
 * su Limulo: la rotta `practice-matches` e' del BFF Limulo, e un tavolo contro il bot si apre dalla rotta `chess/match/:id`, che
 * esiste solo col predicato degli scacchi. Il ruolo `beta` non si ricontrolla qui: lo chiedono la rotta e la Hub.
 * ⚠️ Questa funzione serve a chi decide A RUNTIME (la rotta, i test). Dove il bundler deve eliminare il codice dalla produzione il
 * confronto `import.meta.env.VITE_FEATURE_CHESS_BOT_ENABLED === 'true'` si scrive LETTERALE, nella condizione stessa (router,
 * `components/chess/sections.ts`): un confronto dentro una funzione non si piega.
 */
export function chessBotAcceso(): boolean {
  return env.featureChessBotEnabled && chessLimuloAcceso();
}
